import { Property, AccommodationList } from '@data/models';
import { createServer, Model, Request, Server } from 'miragejs';
import { getBaseEndpoint } from '@data/api/axios';

import * as Property1 from './mock/property-1';

let mirage: Server | undefined = undefined;

function getRequestBody(request: Request): Dict<string> {
  if (typeof request.requestBody === 'string') {
    const json = {};
    const params = request.requestBody.split('&');
    for (let i = 0; i < params.length; i++) {
      const [key, value] = params[i].split('=');
      json[key] = value;
    }
    return json;
  }
  return request.requestBody;
}

export function stopServer() {
  if (mirage) {
    mirage.shutdown();
    mirage = undefined;
  }
}

export function startServer() {
  if (mirage) return mirage;
  mirage = createServer({
    logging: true,

    models: {
      property: Model.extend<Partial<Property>>({}),
      rooms: Model.extend<Partial<AccommodationList>>({}),
    },

    routes() {
      this.urlPrefix = getBaseEndpoint();

      this.post('property_info', (schema, request) => {
        const { property_code } = getRequestBody(request);
        if (property_code === 'mock1') {
          return Property1.property;
        }
        return null;
      });

      this.post('availability_calendar', (schema, request) => {
        const { property_code } = getRequestBody(request);
        if (property_code === 'mock1') {
          return Property1.availability_calendar;
        }
        return null;
      });

      this.post('rooms', (schema, request) => {
        const body = getRequestBody(request);
        const widget_property: number = parseInt(body.widget_property || '0');
        if (widget_property === 1) {
          return Property1.rooms;
        }
        return {};
      });

      this.post('addons', (schema, request) => {
        const body = getRequestBody(request);
        const propertyId: number = parseInt(body.propertyId || '0');
        if (propertyId === 1) {
          return Property1.addons;
        }
        return {};
      });
    },
  });

  return mirage;
}
